import Login from "@/views/public/Login.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/me-connecter",
        name: RouteEnum.LOGIN,
        component: Login
    },
]
